import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="retry-accounting-entry"
// Shows a loading state when the retry form is submitted,
// then Turbo replaces the frame with the server response.
export default class extends Controller {
  static targets = ["content", "loading"]
  static values = { loadingText: { type: String, default: "Saisie d'écriture en cours..." } }

  submit() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("hidden")
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden")
    }
  }
}
